import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { Box, Typography } from '@mui/material'

import { ThemeButton, TextInput } from '../../../../../ui'
import { AttachmentInput } from './attachment-input.component'

const TEXT_AREA_LENGTH = 250

export const RequestChangesDialog = ({ close, appId, getApplication, clientId, requestReview }) => {
  const { formatMessage } = useIntl()

  const [formState, setFormState] = useState({})
  const [loading, setLoading] = useState(false)

  const handleChangeForm = (e) => setFormState({ ...formState, [e.target.name]: e.target.value })

  const handleSubmitForm = (e) => {
    e.preventDefault()
    setLoading(true)
    const payload = { comentario: formState.comentario }
    requestReview(appId, clientId, payload, formState.file)
      .then(() => {
        getApplication(appId)
        setLoading(false)
        close()
      })
      .catch(() => {
        setLoading(false)
      })
  }

  return (
    <Box p={4}>
      <Box mb={4}>
        <Typography variant="h4" color="primary" align="center">
          {formatMessage({ id: 'pages.application.detail.dialogs.requestChanges.title' })}
        </Typography>
      </Box>
      <Typography variant="body1" color="textSecondary" align="left" paragraph>
        {formatMessage({ id: 'pages.application.detail.dialogs.requestChanges.description' })}
      </Typography>
      <form onSubmit={handleSubmitForm}>
        <Box mb={2}>
          <TextInput
            required
            name="comentario"
            title={`${formatMessage({
              id: 'pages.application.detail.dialogs.requestChanges.fields.1.title',
            })}:`}
            placeholder={`Máx. ${TEXT_AREA_LENGTH} caracteres`}
            value={formState['comentario']}
            multiline
            rows={5}
            inputProps={{ maxLength: TEXT_AREA_LENGTH }}
            onChange={handleChangeForm}
          />
        </Box>
        <Box display="flex" alignItems="center" justifyContent="center" mb={3}>
          <AttachmentInput
            {...{ name: 'file', value: formState['file'], onChange: handleChangeForm }}
          />
        </Box>
        <Box display="flex" justifyContent="center">
          <Box mr={6}>
            <ThemeButton color="default" labelM="lg" onClick={close} disabled={loading}>
              {formatMessage({ id: 'global.cancel' })}
            </ThemeButton>
          </Box>
          <ThemeButton
            labelM="lg"
            type="submit"
            color="primary"
            disabled={loading}
            loading={loading}
          >
            {formatMessage({ id: 'global.accept' })}
          </ThemeButton>
        </Box>
      </form>
    </Box>
  )
}
